import React, { useState } from "react";
import { toast } from "react-toastify";
import Modal from "components/modal";
import Password from "components/password";
import PasswordManagement from "context/PasswordManagement";
import { JA } from "utils/strings.ja";
import PasswordRules, { usePasswordRules } from "components/password/PasswordRules";

// Change the signed-in user's own password (Cognito ChangePassword). Opened
// from the account menu in the header, so the page underneath keeps its state.
export default function ChangePasswordModal({ isOpen = false, handleCloseModal = () => {} }) {
  const [form, setForm] = useState({ currentPass: "", newPass: "", repeatPass: "" });
  const [currentError, setCurrentError] = useState("");
  const [error, setError] = useState("");
  const [saving, setSaving] = useState(false);
  const { results, meetsRules } = usePasswordRules(form.newPass);

  const onChange = (event) => {
    const { name, value } = event.target;
    setForm((prev) => ({ ...prev, [name]: value }));
    if (name === "currentPass") setCurrentError("");
    setError("");
  };

  const sameAsOld = !!form.newPass && form.newPass === form.currentPass;
  const mismatch = !!form.repeatPass && form.repeatPass !== form.newPass;
  const canSave =
    !!form.currentPass && meetsRules && !sameAsOld && !!form.repeatPass && !mismatch;

  const save = async () => {
    if (!canSave || saving) return;
    setSaving(true);
    const { statusCode, data } = await PasswordManagement.handleUpdatePassword({
      oldPassword: form.currentPass,
      newPassword: form.newPass,
    });
    setSaving(false);

    if (statusCode === 200) {
      toast(JA.password.changedSuccess, { type: "success" });
      handleCloseModal();
      return;
    }
    // a wrong current password belongs under its own field
    if (data === JA.password.currentIncorrect) setCurrentError(data);
    else setError(data);
  };

  return (
    <Modal
      title={JA.password.change}
      isOpen={isOpen}
      handleCloseModal={handleCloseModal}
      primaryButton={JA.common.save}
      primaryAction={save}
      primaryDisabled={!canSave}
      primaryLoading={saving}
      error={error}
    >
      <form
        onSubmit={(e) => {
          e.preventDefault();
          save();
        }}
      >
        <Password
          id="currentPass"
          name="currentPass"
          label={JA.password.currentPassword}
          placeholder={JA.password.currentPassword}
          autoComplete="current-password"
          value={form.currentPass}
          onChange={onChange}
          error={currentError}
        />
        <Password
          id="newPass"
          name="newPass"
          label={JA.password.newPassword}
          placeholder={JA.password.newPassword}
          autoComplete="new-password"
          value={form.newPass}
          onChange={onChange}
          error={sameAsOld ? JA.password.sameAsOld : ""}
        >
          <PasswordRules results={results} />
        </Password>
        <Password
          id="repeatPass"
          name="repeatPass"
          label={JA.password.newPasswordConfirm}
          placeholder={JA.password.newPasswordConfirm}
          autoComplete="new-password"
          value={form.repeatPass}
          onChange={onChange}
          error={mismatch ? JA.password.mismatch : ""}
        />
        {/* lets Enter submit the form */}
        <button type="submit" className="hidden" aria-hidden="true" tabIndex={-1} />
      </form>
    </Modal>
  );
}
